import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-918ee2bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex items-center justify-center" }
const _hoisted_2 = { class: "component justify-between" }
const _hoisted_3 = { class: "component-info flex justify-center items-center" }
const _hoisted_4 = { class: "component-info flex justify-center items-center" }
const _hoisted_5 = { class: "component-info flex justify-center items-center" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "linearSpace" }, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "flex items-center justify-center mt-20 br16 altBackground p-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t("my_payments")), 1)
    ]),
    (_ctx.result && _ctx.result.length > 0)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "scrollContainer",
          class: "mt-12 br16 altBackground p-4 overflow-y-auto fix-height",
          onScroll: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onScroll && _ctx.onScroll(...args)))
        }, [
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.result, (pay) => {
              return (_openBlock(), _createElementBlock("li", {
                key: pay.sale?.id
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.getBeautifyDate(pay.date)), 1)
                  ]),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("h3", null, _toDisplayString(_ctx.capitalizeFirstLetter(pay.sale?.tenant?.name ?? '')), 1)
                  ]),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("h3", null, _toDisplayString(pay.amountData?.grossAmountStr), 1)
                  ])
                ]),
                _hoisted_6
              ]))
            }), 128))
          ])
        ], 544))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t("dont_have_any_pay")), 1)
        ]))
  ]))
}